import { render, staticRenderFns } from "./view_AiSearch.vue?vue&type=template&id=52497d50&scoped=true"
import script from "./view_AiSearch.vue?vue&type=script&lang=js"
export * from "./view_AiSearch.vue?vue&type=script&lang=js"
import style0 from "./view_AiSearch.vue?vue&type=style&index=0&id=52497d50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52497d50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VRow,VSkeletonLoader})
